import React from "react";
import { Link } from "react-router-dom";
import "./Form.css";

export const Form = (props) => {
  return (
    <div className="login-form">
      {props.inputs.map((input, i) => (
        <Input
          key={`input_${i}`}
          target={input.target}
          type={input.type}
          placeholder={input.placeholder}
          handleChangeInput={props.handleChangeInput}
        />
      ))}
      {props.error && (
        <p style={{ paddingTop: 4 }} className="error-message">
          {props.generalError}
        </p>
      )}
      {/* {props.externalLink && (
        <Link to="/newPasswordRequest">
          <p>{props.externalLink.text}</p>
        </Link>
      )} */}
      {props.checkboxes && (
        <div className="login-form-checkbox-cointaner">
          {props.checkboxes.map((checkbox, i) => (
            <Checkbox
              id={`checkbox_${i}`}
              key={`checkbox_${i}`}
              target={checkbox.target}
              label={checkbox.label}
              handleChangeInput={props.handleChangeInput}
            />
          ))}
        </div>
      )}
      <Button
        disabled={props.submitButton.disabled}
        handleSubmit={props.handleSubmit}
        loading={props.submitButton.loading}
        text={props.submitButton.text}
      />
    </div>
  );
};
export const Input = (props) => {
  return (
    <>
      <input
        onChange={(event) =>
          props.handleChangeInput(props.target, event.target.value)
        }
        type={props.type}
        placeholder={props.placeholder}
        style={{ border: props.error ? "2px solid red" : "none" }}
      ></input>
      {props.error && <p className="error-message">{props.error}</p>}
    </>
  );
};
export const Checkbox = (props) => {
  return (
    <div>
      <input
        onChange={(event) =>
          props.handleChangeInput(props.target, event.target.checked)
        }
        type="checkbox"
        id={props.id}
      ></input>
      <label htmlFor={props.id}>{props.label}</label>
    </div>
  );
};

export const Button = (props) => {
  return (
    <button
      disabled={props.disabled}
      type="button"
      onClick={props.handleSubmit}
      style={{ opacity: props.disabled ? 0.5 : 1 }}
      className={props.className}
    >
      {props.loading ? <div className="loader"></div> : props.text}
    </button>
  );
};
